import {
  LayoutDashboard,
  Database,
  BookOpen,
  UserPlus,
  Calendar,
  Users,
  ClipboardCheck,
  Award,
  Shield,
  Percent,
  FileText,
  Settings,
  BarChart3,
  LineChart,
  Telescope,
  Cpu,
  Target,
  GitBranch,
  TrendingUp,
  Search,
  FolderKanban,
  Layers,
  Sparkles,
} from 'lucide-react';

/** Sidebar entries for Training & Skill Development (M12). */
export function getTrainingDevelopmentNavChildren() {
  return [
    { path: '/training-recommendations', label: 'Legacy recommendations (M5)', icon: BarChart3 },
    {
      path: '/training-development/learning-ops',
      label: 'Learning Operations & Administration',
      icon: FolderKanban,
      children: [
        { path: '/training-development/dashboard', label: 'Training Dashboard', icon: LayoutDashboard },
        { path: '/training-development/training-master', label: 'Training Master', icon: Database },
        { path: '/training-development/catalog', label: 'Learning Catalog', icon: BookOpen },
        { path: '/training-development/nominations', label: 'Nomination & Enrollment', icon: UserPlus },
        { path: '/training-development/calendar', label: 'Calendar & Scheduling', icon: Calendar },
        { path: '/training-development/batches', label: 'Batch / Cohort Management', icon: Layers },
        { path: '/training-development/delivery', label: 'Learning Delivery', icon: Sparkles },
        { path: '/training-development/attendance', label: 'Attendance & Participation', icon: Users },
        { path: '/training-development/assessments', label: 'Assessments & Evaluation', icon: ClipboardCheck },
        { path: '/training-development/pre-post-assessment', label: 'Pre / Post Assessment', icon: Target },
        { path: '/training-development/certifications', label: 'Certification Management', icon: Award },
        { path: '/training-development/compliance', label: 'Compliance Training', icon: Shield },
        { path: '/training-development/trainers', label: 'Instructors / Trainers', icon: Users },
        { path: '/training-development/vendors', label: 'External Training & Vendors', icon: GitBranch },
        { path: '/training-development/budget', label: 'Budget & Cost', icon: Percent },
        { path: '/training-development/documents', label: 'Documents & Records', icon: FileText },
        { path: '/training-development/approvals', label: 'Workflow & Approvals', icon: Settings },
        { path: '/training-development/governance', label: 'Governance & Controls', icon: Shield },
      ],
    },
    {
      path: '/training-development/capability',
      label: 'Capability Development & Employee Growth',
      icon: TrendingUp,
      children: [
        { path: '/training-development/needs-identification', label: 'Training Needs Identification', icon: Target },
        { path: '/training-development/competency-gap', label: 'Competency Gap Mapping', icon: BarChart3 },
        { path: '/training-development/idp', label: 'Individual Development Plans', icon: FileText },
        { path: '/training-development/role-learning-paths', label: 'Role-Based Learning Paths', icon: Layers },
        { path: '/training-development/skill-learning-paths', label: 'Skill-Based Learning Paths', icon: BookOpen },
        { path: '/training-development/leadership-development', label: 'Leadership Development', icon: Shield },
        { path: '/training-development/upskilling-reskilling', label: 'Technical Upskilling & Reskilling', icon: Cpu },
        { path: '/training-development/behavioral-skills', label: 'Behavioral & Soft Skills', icon: Users },
        { path: '/training-development/onboarding-training', label: 'Onboarding Training', icon: Calendar },
        { path: '/training-development/ojt', label: 'OJT / On-the-Job Training', icon: ClipboardCheck },
        { path: '/training-development/knowledge-transfer', label: 'Knowledge Transfer', icon: GitBranch },
        { path: '/training-development/career-linked-training', label: 'Career-linked Training', icon: TrendingUp },
        { path: '/training-development/performance-linked-learning', label: 'Performance-linked Learning', icon: LineChart },
        { path: '/training-development/project-demand-linked-planning', label: 'Project / Demand-linked Planning', icon: Target },
        { path: '/training-development/succession-development', label: 'Succession-linked Development', icon: Shield },
      ],
    },
    {
      path: '/training-development/intelligence',
      label: 'Intelligence, Analytics & Strategic Planning',
      icon: Telescope,
      children: [
        { path: '/training-development/analytics', label: 'Training Analytics & Dashboards', icon: BarChart3 },
        { path: '/training-development/effectiveness', label: 'Training Effectiveness', icon: LineChart },
        { path: '/training-development/feedback', label: 'Feedback & Satisfaction', icon: Users },
        { path: '/training-development/post-training-impact', label: 'Post-Training Impact', icon: TrendingUp },
        { path: '/training-development/compliance-audit', label: 'Learning Compliance & Audit', icon: Shield },
        { path: '/training-development/forecasting', label: 'Forecasting & Capability Planning', icon: Telescope },
        { path: '/training-development/ai-learning-recommendations', label: 'AI Learning Recommendations', icon: Sparkles },
        { path: '/training-development/ai-skill-gap-prediction', label: 'AI Skill Gap Prediction', icon: Cpu },
        { path: '/training-development/learning-search', label: 'Learning Search & NL Query', icon: Search },
        { path: '/training-development/strategic-capability-intelligence', label: 'Strategic Capability Intelligence', icon: Layers },
        {
          path: '/cost-optimization-automation/training-automation',
          label: 'Training Cost & Automation (COA)',
          icon: Sparkles,
        },
      ],
    },
  ];
}
